import Vue from "vue";
import VueRouter from "vue-router";

// BASIC PACKAGE
import Unavailable from "../views/Unavailable.vue";
import AccessDenied from "../views/Error-403.vue";
import NotFound from "../views/Error-404.vue";
import Error500 from "../views/Error-500.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/admin",
    component: () => import("../views/admin/_root.vue"),
    children: [
      {
        name: "surveys",
        path: "surveys",
        component: () => import("../views/admin/surveys.vue"),
      },
      {
        name: "editor",
        path: "surveys/:id/editor",
        component: () => import("../views/admin/surveyEditor.vue"),
      },
      {
        name: "surveyCodes",
        path: "surveys/:id/codes",
        component: () => import("../views/admin/surveyCodes.vue"),
      },
      {
        name: "entities",
        path: "entities",
        component: () => import("../views/admin/entities.vue"),
      },
      {
        name: "tenant-users",
        path: "tenant-users",
        component: () => import("../views/admin/tenant-users.vue"),
      },
      {
        name: "admins",
        path: "app/users",
        component: () => import("../views/admin/admins.vue"),
      },
      {
        name: "reporting",
        path: "surveys/:id/reporting",
        component: () => import("../views/admin/reporting.vue"),
      },
    ],
  },
  {
    name: 'portal',
    path: "/portal/:tenantId",
    component: () => import("../views/portal/_root.vue")
  },
  {
    name: "standard_template",
    path: "/survey/s/:tenantId/:id",
    component: () => import("../views/Survey.vue"),
  },
  {
    name: "public_report",
    path: "/public-report/:tenantId/:id",
    component: () => import("../views/PublicReport.vue"),
  },
  // CUSTOM VIEWS
  {
    name: "nctwcs",
    path: "/nctwcs",
    component: () => import("../views/surveys/nctwcs/Results.vue"),
    children: [
      {
        name: "nctwcs.results.overview",
        path: ":id",
        component: () =>
          import("../views/surveys/nctwcs/Results.ResponseRate.vue"),
      },
    ],
  },
  {
    name: "liveResults_nctwcs",
    path: "/live-results/nctwcs/:id/re",
    component: () => import("../views/surveys/nctwcs/LiveResults.vue"),
  },
  {
    name: "nc_dpi_template",
    path: "/survey/nc_dpi/:id",
    component: () => import("../views/surveys/nctwcs/Survey.vue"),
  },

  // SYSTEM ROUTES
  {
    name: "error:500",
    path: "/error/500",
    component: Error500,
  },
  {
    name: "accessDenied",
    path: "/error/403",
    component: AccessDenied,
  },
  {
    name: "unavailable",
    path: "/unavailable",
    component: Unavailable,
  },
  {
    name: "notFound",
    path: "/*", // CATCH ALL PATH MUST BE LAST ROUTE IN LIST
    component: NotFound,
  },
];

const router = new VueRouter({
  historyMode: true,
  routes,
});

router.beforeEach((to, from, next) => {
  if (["/admin", "/admin/"].some((x) => x === to.path)) {
    next({ name: "surveys" });
  } else next();
});

export default router;
